<div class="p-4 bg-grey" rt="account-support-component">
  <!-- Header -->
  <div rt="account-support-component-header">
    <div class="d-flex section-header header-text">
      {{ headerText }}
    </div>
    <div class="d-flex paragraph-text text-grey mt-1 complementary-text">
      {{ complementaryText }}
    </div>
  </div>
  <!-- Thumbnail -->
  <div *ngIf="accountSupportUser" class="mt-3" rt="account-support-component-thumbnail">
    <common-user-thumbnail [imagePath]="accountSupportUser.profilePicture" [userName]="accountSupportUser.username"> </common-user-thumbnail>
  </div>
  <!-- Data Contact -->
  <div rt="account-support-component-contact">
    <div class="d-flex d-md-inline-flex mt-3 mr-3">
      <div class="icon-container d-inline mr-2">
        <i class="icon-envelope text-grey"></i>
      </div>
      <div class="d-inline-flex align-self-center text-green">
        <a (click)="emailSupport()" class="cursor-pointer">
          {{ currentEmail }}
        </a>
      </div>
    </div>
    <div class="d-flex d-md-inline-flex mt-3">
      <div class="icon-container d-inline">
        <i class="icon-phone text-grey ml-n1"></i>
      </div>
      <div class="d-inline align-self-center text-green">
        <a (click)="callSupport()" class="cursor-pointer">
          {{ currentPhone }}
        </a>
      </div>
    </div>
  </div>
</div>
